// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"1ba82a71ebbefe3703c9","823":"b46d749c985575c32b6e"}[chunkId] + ".js";
};